module.exports = __webpack_public_path__ + "img/lavraki.6c54a91e.jpg";